module.exports = __webpack_public_path__ + "static/media/porzio_global_spend_transparency_logo_small.c6365b76.png";